/*eslint new-cap:0 */

import _ from 'underscore';
import 'backbone';
import config from '@bingads-webui-component-legacy/config/index';
import AutoTargetView from '@bingads-webui-campaign-legacy/auto-targets/view/create/index';
import { adGroupTypeEnum } from '@bingads-webui-campaign-legacy/adgroup-create-advanced/util/adGroupTypeEnum';

const isDSAMixedModeCampaignEnabled = _.result(config.get('Permissions'), 'IsDSAMixedModeCampaignEnabled', false);

export function decorate(view) {
  return view.extend({
    initialize(options = {}) {
      _.bind(view.prototype.initialize, this, options)();
      this.subView = new AutoTargetView(_.extend(options, {
        showHeader: !options.hideHeader,
        defaultBid: options.defaultBid,
        setting: { // TODO [ericwa]: will add other campaign setting like target source in setting
          DomainName: options.context.get('Campaign').DomainName,
          Language: options.context.get('Campaign').DomainLanguage,
          Source: options.context.get('Campaign').TargetingSource,
        },
        isForVNext: options.isForVNext,
      }));
      this.changes = [];

      if (isDSAMixedModeCampaignEnabled) {
        this.ko_model.AdGroupType(adGroupTypeEnum.SearchDynamic);
      }

      this.on('updateAutoTargetEditorSetting', (setting) => {
        this.setAutoTargetsViewSetting(setting);
      });
    },

    setAutoTargetsViewSetting (setting) {
      this.subView.trigger('update:setting', setting, true);
    },

    getChanges() {
      if (this.hasChanges || this.subView.hasChanges()) {
        const serializedAdGroup = this.ko_model.toObject();
        const adGroupId = _.isNaN(serializedAdGroup.Id) || serializedAdGroup.Id < 1 ? null : serializedAdGroup.Id;

        const autoTargets = this.subView.getChanges();

        _.each(autoTargets, (target) => {
          if (serializedAdGroup.Id > 0) {
            target.AdGroup = {
              Id: adGroupId,
            };
          } else {
            target.AdGroupName = serializedAdGroup.Name;
            target.CampaignName = serializedAdGroup.CampaignName;
          }
        });

        serializedAdGroup.DsaTargets = autoTargets;
        serializedAdGroup['Client Id'] = `${this.ko_model.options.index}`;

        if (_.isNull(adGroupId)) {
          const keys = ['Client Id', 'Name', 'Campaign', 'Language', 'DsaTargets', 'PricingModel', 'Medium'];

          if (isDSAMixedModeCampaignEnabled) {
            keys.push('AdGroupType');
          }

          return _.pick(serializedAdGroup, keys);
        } else {
          return _.pick(serializedAdGroup, 'Client Id', 'Id', 'Name', 'Campaign', 'DsaTargets');
        }
      }
      return null;
    },

    getContextObject() {
      const adGroupsStored = this.options && this.options.context && this.options.context.get('AdGroups');
      const currentId = this.ko_model.Id();

      let object = {
        Id: currentId,//eslint-disable-line
        Name: this.ko_model.Name(),//eslint-disable-line
      };

      if (adGroupsStored) {
        object.Bid = _.chain(adGroupsStored).where({Id: currentId}).first().result('Bid').value();
      }

      if (isDSAMixedModeCampaignEnabled) {
        object.AdGroupType = adGroupTypeEnum.SearchDynamic;
      }

      return object;
    },

    updateViewModels(data) {
      _.bind(view.prototype.updateViewModels, this, data)();
      this.subView.updateViewModels(data.DsaTargets);
    },

    updateViewModelsOnError(response) {
      _.bind(view.prototype.updateViewModelsOnError, this, response, 'DsaTargets')();

      if (_.isEmpty(response.entity.errors)) {
        this.subView.updateViewModels(response.entity.DsaTargets);
      }
    },

    updateOnVisible() {
      const adGroupBid = _.result(this.getContextObject(), 'Bid', this.options.defaultBid);

      this.subView.trigger('update:bid', adGroupBid);
      this.subView.trigger('update:setting', {
        DomainName: this.options.context.get('Campaign').DomainName,
        Language: this.options.context.get('Campaign').DomainLanguage,
        Source: this.options.context.get('Campaign').TargetingSource,
      }, true);
    },
  });
}
